// atlas web — belépési pont
// részletes architektúra: docs/_architecture.md
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Outfit UI-font (DocuShare/MissionControll reskin) — 300–800 súlyok, self-hosted (@fontsource)
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/outfit/800.css';

import { parseSearchAsStrings, stringifySearchAsStrings } from './lib/search-params';
import { routeTree } from './routeTree.gen';
import './styles/globals.css';

// a keresőparam mindig SZTRING (a `validateSearch`-ek azt várják) — indoklás: `lib/search-params.ts`
const router = createRouter({
  routeTree,
  parseSearch: parseSearchAsStrings,
  stringifySearch: stringifySearchAsStrings,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root not found');

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
